<template>
  <div>
    <pxkeji-rightHeader />



    <div class="pxkeji-right-box">
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
        :scroll="{ x: 1300 }"
      >
        
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>课程总数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    dataIndex: "courseId",
    key: "courseId",
    align: "center",
    title: "课程ID"
  },
  {
    dataIndex: "courseName",
    key: "courseName",
    align: "center",
    title: "课程名称"
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "教师"
  },
  // {
  //   dataIndex: "created_at",
  //   key: "created_at",
  //   align: "center",
  //   title: "创建时间"
  // },
  
];

var that;
export default {
  name: "lazCourse",
  data() {
    return {
      isloading:false,
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 1000 //页容
        }
      },
    };
  },
  components: {
  },
  mounted: function() {
    this.$nextTick(function() {
      this.GetList();
    });
  },
  methods: {
    searchList(){
      this.GetList();
    },
    onChange(p){
      this.list.pagination.current = p.current;
      this.GetList();
    },
    async GetList() {
      //获取列表
      this.isloading = true;
      var res = await this.$api.course
        .getzjwCourseList({page:this.list.pagination.current,pageSize:this.list.pagination.defaultPageSize});

        this.isloading = false;
        if (res.errorCode == this.$msg.responseCode.success) {
          this.list.datas = res.data.lists;
          this.list.pagination.total = Number(res.data.total);
        } else {
          this.$message.error(res.errorMsg);
        }

        // .then(res => {
        //   this.isloading = false;
        //   if (res.errorCode == this.$msg.responseCode.success) {
        //     this.list.datas = res.data.records;
        //     this.list.pagination.total = Number(res.data.total);
        //   } else {
        //     this.$message.error(res.errorMsg);
        //   }
        // })
        // .catch(() => {
        //   this.isloading = false;
        // });
    },
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

